module.exports = __webpack_public_path__ + "static/media/mail_icon_2.26d5a6a3.svg";